export const DEFAULT_INPUT_MAX_LENGTH = 255;
export const EMAIL_FORMAT = /^[A-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[A-Z0-9-_]+(\.[A-Z0-9-]+)+$/gi;

export const TURNSTILE_VERIFICATION_FAILED_CODES = [
    "TurnstileVerificationFailed",
    "invalid-input-response",
    "missing-input-secret",
    "missing-input-response",
    "invalid-input-secret",
    "bad-request",
    "internal-error",
    "timeout-or-duplicate",
];
